import { cn } from "@/lib/utils";

const LEVELS = [
  ["prvi", "Prvi strani jezik"],
  ["drugi", "Drugi strani jezik"],
];

export const LanguageLevelToggle = ({ value, onChange }) => (
  <div
    className="inline-flex rounded-lg border border-slate-200 bg-white p-0.5"
    role="radiogroup"
    data-testid="language-level-toggle"
  >
    {LEVELS.map(([val, label]) => (
      <button
        key={val}
        type="button"
        role="radio"
        aria-checked={value === val}
        onClick={() => onChange(val)}
        data-testid={`language-level-${val}`}
        className={cn(
          "px-3 py-1.5 text-xs font-medium rounded-md transition-colors",
          value === val ? "bg-blue-600 text-white" : "text-slate-600 hover:bg-slate-50"
        )}
      >
        {label}
      </button>
    ))}
  </div>
);

export default LanguageLevelToggle;
